@if (tag) {
  <div class="flex items-center gap-1" [ngStyle]="{ color: TAGS_COLORS.grey }">
    <mat-icon
      [ngStyle]="{ color: tag?.color ?? TAGS_COLORS.grey }"
      class="small">
      label
    </mat-icon>
    <span class="leading-none">{{ tag.tag }}</span>
    @if (withDelete) {
      <div
        class="flex cursor-pointer items-center justify-center rounded-full p-1 hover:bg-red-100"
        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
        (click)="$event.stopPropagation(); deleteTag.emit(tag)">
        <mat-icon class="small" color="warn" mat-icon-button>close</mat-icon>
      </div>
    }
  </div>
}
